import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { SettingsBase } from 'settings';
import { filterSectionsByPrivilege, SettingsOption } from 'settings/utils';
import { setUserPrivileges } from 'utility/cache/ui';
import { AccountingPeriodEntry } from './accountingPeriodEntry/list';
import { CommunicationChannel } from './communicationChannels/list';
import { CommunicationGroup } from './communicationGroup/list';
import { PurchaseCards } from './purchaseCards/list';
import { TagCategorySetup } from './tagCategorySetup/list';
import { TagSetup } from './tagSetup/list';
import { TagsGroupSetup } from './tagsGroupSetup/list';

const SETTINGS_PATH = '/project-settings';

export const sections: SettingsOption[] = [
  {
    name: 'Purchase Cards',
    path: `${SETTINGS_PATH}/purchase-cards`,
    component: PurchaseCards,
    routeName: 'PCARD_ACCOUNT',
    icon: 'PaymentCard',
  },
  {
    name: 'Communications',
    icon: 'CommentNext',
    children: [
      {
        name: 'Channels',
        path: `${SETTINGS_PATH}/channels`,
        component: CommunicationChannel,
        routeName: 'CHANNELS',
        icon: 'CommentNext',
      },
      {
        name: 'Communication Groups',
        path: `${SETTINGS_PATH}/groups`,
        component: CommunicationGroup,
        routeName: 'COMMUNICATION_GROUPS',
        icon: 'CommentNext',
      },
    ],
  },
  {
    name: 'Tagging',
    icon: 'Tag',
    children: [
      {
        name: 'Tags',
        path: `${SETTINGS_PATH}/tags`,
        component: TagSetup,
        routeName: 'TAGS',
      },
      {
        name: 'Tag Groups',
        path: `${SETTINGS_PATH}/tag-groups`,
        component: TagsGroupSetup,
        routeName: 'TAG_GROUPS',
        icon: 'TagSolid',
      },
      {
        name: 'Tag Categories',
        path: `${SETTINGS_PATH}/tag-categories`,
        component: TagCategorySetup,
        routeName: 'TAG_CATEGORIES',
        icon: 'TagUnknown',
      },
    ],
  },
  {
    name: 'Accounting Periods',
    path: `${SETTINGS_PATH}/accounting-periods`,
    component: AccountingPeriodEntry,
    icon: 'CalendarSettings',
    routeName: 'ACCOUNTING_PERIOD',
  },
];

export const ProjectSettings: React.FC = () => {
  const privileges = useReactiveVar(setUserPrivileges);
  const sectionsList = filterSectionsByPrivilege(sections, privileges);

  return (
    <SettingsBase
      basePath={SETTINGS_PATH}
      sections={sectionsList}
      title="Project Settings"
    />
  );
};
